import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import MobileNav from '../../components/ui/MobileNav';
import QuickActions from '../../components/ui/QuickActions';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Select from '../../components/ui/Select';
import Input from '../../components/ui/Input';
import TransactionCard from './components/TransactionCard';
import EscrowCard from './components/EscrowCard';
import RevenueChart from './components/RevenueChart';
import PaymentMethodCard from './components/PaymentMethodCard';
import InvoiceCard from './components/InvoiceCard';
import StatCard from './components/StatCard';
import TransactionDetailModal from './components/TransactionDetailModal';

const PaymentCenter = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [dateRange, setDateRange] = useState('30');
  const [transactionType, setTransactionType] = useState('all');
  const [chartType, setChartType] = useState('line');
  const [userRole] = useState('artist');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    document.title = 'Ödeme Merkezi - Ozymakers';
  }, []);

  const stats = [
    {
      title: 'Toplam Gelir',
      value: 45750,
      change: 12.5,
      icon: 'TrendingUp',
      color: 'success'
    },
    {
      title: 'Bekleyen Ödemeler',
      value: 8500,
      change: -5.2,
      icon: 'Clock',
      color: 'warning'
    },
    {
      title: 'Toplam Komisyon',
      value: 4575,
      change: 8.3,
      icon: 'Percent',
      color: 'accent'
    },
    {
      title: 'Emanet Tutarı',
      value: 12300,
      icon: 'Shield',
      color: 'primary'
    }
  ];

  const transactions = [
    {
      id: 1,
      type: 'payment',
      description: 'Spotify Tanıtım Kampanyası Ödemesi',
      reference: 'TRX-2025-001234',
      amount: 2500,
      commission: 250,
      status: 'completed',
      date: '2025-11-28T14:30:00',
      paymentMethod: {
        name: 'Ziraat Bankası',
        last4: '4567'
      },
      notes: 'Kampanya başarıyla tamamlandı. 50.000 dinlenme hedefine ulaşıldı.',
      history: [
        { action: 'Ödeme başlatıldı', date: '2025-11-28T14:30:00' },
        { action: 'Komisyon hesaplandı', date: '2025-11-28T14:31:00' },
        { action: 'Ödeme onaylandı', date: '2025-11-28T14:35:00' },
        { action: 'Hesaba aktarıldı', date: '2025-11-28T14:40:00' }
      ]
    },
    {
      id: 2,
      type: 'withdrawal',
      description: 'Banka Hesabına Para Çekme',
      reference: 'TRX-2025-001235',
      amount: 5000,
      status: 'processing',
      date: '2025-11-27T10:15:00',
      paymentMethod: {
        name: 'İş Bankası',
        last4: '8901'
      },
      history: [
        { action: 'Çekim talebi oluşturuldu', date: '2025-11-27T10:15:00' },
        { action: 'İşlem onaylandı', date: '2025-11-27T10:20:00' },
        { action: 'Bankaya gönderildi', date: '2025-11-27T11:00:00' }
      ]
    },
    {
      id: 3,
      type: 'commission',
      description: 'Instagram Reels Kampanyası Komisyonu',
      reference: 'TRX-2025-001236',
      amount: 350,
      status: 'completed',
      date: '2025-11-26T16:45:00',
      history: [
        { action: 'Komisyon hesaplandı', date: '2025-11-26T16:45:00' },
        { action: 'Ödeme tamamlandı', date: '2025-11-26T16:50:00' }
      ]
    },
    {
      id: 4,
      type: 'payment',
      description: 'TikTok Viral Kampanyası',
      reference: 'TRX-2025-001237',
      amount: 3200,
      commission: 320,
      status: 'pending',
      date: '2025-11-25T09:20:00',
      paymentMethod: {
        name: 'Garanti BBVA',
        last4: '2345'
      },
      history: [
        { action: 'Ödeme başlatıldı', date: '2025-11-25T09:20:00' },
        { action: 'Onay bekleniyor', date: '2025-11-25T09:25:00' }
      ]
    },
    {
      id: 5,
      type: 'refund',
      description: 'İptal Edilen Kampanya İadesi',
      reference: 'TRX-2025-001238',
      amount: 1500,
      status: 'completed',
      date: '2025-11-24T13:10:00',
      notes: 'Kampanya karşılıklı anlaşma ile iptal edildi.',
      history: [
        { action: 'İade talebi oluşturuldu', date: '2025-11-24T13:10:00' },
        { action: 'İade onaylandı', date: '2025-11-24T13:15:00' },
        { action: 'Hesaba iade edildi', date: '2025-11-24T13:30:00' }
      ]
    }
  ];

  const escrowAccounts = [
    {
      id: 1,
      campaignName: 'YouTube Shorts Serisi',
      influencerName: '@musicinfluencer',
      amount: 4500,
      completedMilestones: 2,
      totalMilestones: 3,
      startDate: '2025-11-20',
      endDate: '2025-12-20',
      nextMilestone: 'Final video yayını ve performans raporu'
    },
    {
      id: 2,
      campaignName: 'Instagram Story Kampanyası',
      influencerName: '@trendymusic',
      amount: 2800,
      completedMilestones: 3,
      totalMilestones: 3,
      startDate: '2025-11-15',
      endDate: '2025-11-30',
      nextMilestone: null
    },
    {
      id: 3,
      campaignName: 'Spotify Playlist Tanıtımı',
      influencerName: '@playlistcurator',
      amount: 3500,
      completedMilestones: 1,
      totalMilestones: 4,
      startDate: '2025-11-25',
      endDate: '2025-12-25',
      nextMilestone: 'Playlist ekleme ve ilk hafta raporu'
    }
  ];

  const revenueData = [
    { month: 'Haz', revenue: 28500, commission: 2850 },
    { month: 'Tem', revenue: 32100, commission: 3210 },
    { month: 'Ağu', revenue: 29800, commission: 2980 },
    { month: 'Eyl', revenue: 35600, commission: 3560 },
    { month: 'Eki', revenue: 38900, commission: 3890 },
    { month: 'Kas', revenue: 45750, commission: 4575 }
  ];

  const paymentMethods = [
    {
      id: 1,
      type: 'bank',
      name: 'Ana Hesap',
      bankName: 'Ziraat Bankası',
      accountNumber: 'TR330006100519786457841326',
      holderName: 'Ahmet Yılmaz',
      isDefault: true
    },
    {
      id: 2,
      type: 'bank',
      name: 'İkincil Hesap',
      bankName: 'İş Bankası',
      accountNumber: 'TR640006400000111222333444',
      holderName: 'Ahmet Yılmaz',
      isDefault: false
    },
    {
      id: 3,
      type: 'card',
      name: 'Kredi Kartı',
      bankName: 'Garanti BBVA',
      accountNumber: '5528790000001234',
      holderName: 'Ahmet Yılmaz',
      isDefault: false
    }
  ];

  const invoices = [
    {
      id: 1,
      number: 'INV-2025-001',
      description: 'Spotify Tanıtım Kampanyası',
      amount: 2500,
      date: '2025-11-28',
      dueDate: '2025-12-28',
      status: 'paid'
    },
    {
      id: 2,
      number: 'INV-2025-002',
      description: 'TikTok Viral Kampanyası',
      amount: 3200,
      date: '2025-11-25',
      dueDate: '2025-12-25',
      status: 'pending'
    },
    {
      id: 3,
      number: 'INV-2025-003',
      description: 'Instagram Reels Serisi',
      amount: 1800,
      date: '2025-11-20',
      dueDate: '2025-11-30',
      status: 'overdue'
    }
  ];

  const dateRangeOptions = [
    { value: '7', label: 'Son 7 Gün' },
    { value: '30', label: 'Son 30 Gün' },
    { value: '90', label: 'Son 90 Gün' },
    { value: 'custom', label: 'Özel Tarih' }
  ];

  const transactionTypeOptions = [
    { value: 'all', label: 'Tüm İşlemler' },
    { value: 'payment', label: 'Ödemeler' },
    { value: 'withdrawal', label: 'Para Çekme' },
    { value: 'commission', label: 'Komisyonlar' },
    { value: 'refund', label: 'İadeler' }
  ];

  const filteredTransactions = transactions?.filter(transaction => {
    const matchesType = transactionType === 'all' || transaction?.type === transactionType;
    const matchesSearch = transaction?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
                         transaction?.reference?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    return matchesType && matchesSearch;
  });

  const handleReleaseEscrow = (escrow) => {
    console.log('Emanet serbest bırakılıyor:', escrow);
  };

  const handleDisputeEscrow = (escrow) => {
    console.log('Emanet itirazı:', escrow);
  };

  const handleEditPaymentMethod = (method) => {
    console.log('Ödeme yöntemi düzenleniyor:', method);
  };

  const handleDeletePaymentMethod = (method) => {
    console.log('Ödeme yöntemi siliniyor:', method);
  };

  const handleSetDefaultPaymentMethod = (method) => {
    console.log('Varsayılan ödeme yöntemi ayarlanıyor:', method);
  };

  const handleDownloadInvoice = (invoice) => {
    console.log('Fatura indiriliyor:', invoice);
  };

  const handleViewInvoice = (invoice) => {
    console.log('Fatura görüntüleniyor:', invoice);
  };

  const tabs = [
    { id: 'overview', label: 'Genel Bakış', icon: 'LayoutDashboard' },
    { id: 'transactions', label: 'İşlemler', icon: 'Receipt' },
    { id: 'escrow', label: 'Emanet Hesapları', icon: 'Shield' },
    { id: 'methods', label: 'Ödeme Yöntemleri', icon: 'CreditCard' },
    { id: 'invoices', label: 'Faturalar', icon: 'FileText' }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16 pb-20 md:pb-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">Ödeme Merkezi</h1>
            <p className="text-muted-foreground">
              Finansal işlemlerinizi yönetin, emanet hesaplarını takip edin ve faturalarınızı görüntüleyin
            </p>
          </div>

          <div className="mb-6 border-b border-border overflow-x-auto">
            <nav className="flex gap-1 min-w-max" role="tablist">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`
                    flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-smooth whitespace-nowrap
                    ${activeTab === tab?.id
                      ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                    }
                  `}
                  role="tab"
                  aria-selected={activeTab === tab?.id}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span>{tab?.label}</span>
                </button>
              ))}
            </nav>
          </div>

          {activeTab === 'overview' && (
            <div className="space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {stats?.map((stat, index) => (
                  <StatCard key={index} {...stat} />
                ))}
              </div>

              <div className="bg-card border border-border rounded-lg p-6">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-bold text-foreground">Gelir Analizi</h2>
                  <div className="flex items-center gap-2">
                    <Select
                      options={dateRangeOptions}
                      value={dateRange}
                      onChange={setDateRange}
                      className="w-40"
                    />
                    <div className="flex bg-muted rounded-md p-1">
                      <button
                        onClick={() => setChartType('line')}
                        className={`px-3 py-1 rounded text-sm transition-smooth ${
                          chartType === 'line' ? 'bg-card shadow-sm' : 'hover:bg-card/50'
                        }`}
                      >
                        <Icon name="TrendingUp" size={16} />
                      </button>
                      <button
                        onClick={() => setChartType('bar')}
                        className={`px-3 py-1 rounded text-sm transition-smooth ${
                          chartType === 'bar' ? 'bg-card shadow-sm' : 'hover:bg-card/50'
                        }`}
                      >
                        <Icon name="BarChart3" size={16} />
                      </button>
                    </div>
                  </div>
                </div>
                <RevenueChart data={revenueData} type={chartType} />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="bg-card border border-border rounded-lg p-6">
                  <h2 className="text-xl font-bold text-foreground mb-4">Son İşlemler</h2>
                  <div className="space-y-3">
                    {transactions?.slice(0, 3)?.map((transaction) => (
                      <TransactionCard
                        key={transaction?.id}
                        transaction={transaction}
                        onClick={setSelectedTransaction}
                      />
                    ))}
                  </div>
                  <Button
                    variant="outline"
                    onClick={() => setActiveTab('transactions')}
                    className="w-full mt-4"
                  >
                    Tüm İşlemleri Görüntüle
                  </Button>
                </div>

                <div className="bg-card border border-border rounded-lg p-6">
                  <h2 className="text-xl font-bold text-foreground mb-4">Aktif Emanet Hesapları</h2>
                  <div className="space-y-4">
                    {escrowAccounts?.slice(0, 2)?.map((escrow) => (
                      <EscrowCard
                        key={escrow?.id}
                        escrow={escrow}
                        onRelease={handleReleaseEscrow}
                        onDispute={handleDisputeEscrow}
                      />
                    ))}
                  </div>
                  <Button
                    variant="outline"
                    onClick={() => setActiveTab('escrow')}
                    className="w-full mt-4"
                  >
                    Tüm Emanet Hesaplarını Görüntüle
                  </Button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'transactions' && (
            <div className="space-y-6">
              <div className="bg-card border border-border rounded-lg p-6">
                <div className="flex flex-col sm:flex-row gap-4 mb-6">
                  <Input
                    type="search"
                    placeholder="İşlem ara..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e?.target?.value)}
                    className="flex-1"
                  />
                  <Select
                    options={transactionTypeOptions}
                    value={transactionType}
                    onChange={setTransactionType}
                    className="w-full sm:w-48"
                  />
                  <Select
                    options={dateRangeOptions}
                    value={dateRange}
                    onChange={setDateRange}
                    className="w-full sm:w-48"
                  />
                </div>

                <div className="space-y-3">
                  {filteredTransactions?.length > 0 ? (
                    filteredTransactions?.map((transaction) => (
                      <TransactionCard
                        key={transaction?.id}
                        transaction={transaction}
                        onClick={setSelectedTransaction}
                      />
                    ))
                  ) : (
                    <div className="text-center py-12">
                      <Icon name="Receipt" size={48} className="mx-auto mb-4 opacity-50" />
                      <p className="text-muted-foreground">İşlem bulunamadı</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'escrow' && (
            <div className="space-y-6">
              <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 flex items-start gap-3">
                <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Emanet Hesapları Hakkında</h3>
                  <p className="text-sm text-muted-foreground">
                    Emanet hesapları, kampanya tamamlanana kadar ödemelerin güvenli bir şekilde tutulmasını sağlar. 
                    Tüm kilometre taşları tamamlandığında ödeme otomatik olarak serbest bırakılır.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {escrowAccounts?.map((escrow) => (
                  <EscrowCard
                    key={escrow?.id}
                    escrow={escrow}
                    onRelease={handleReleaseEscrow}
                    onDispute={handleDisputeEscrow}
                  />
                ))}
              </div>
            </div>
          )}

          {activeTab === 'methods' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-xl font-bold text-foreground mb-1">Ödeme Yöntemleriniz</h2>
                  <p className="text-sm text-muted-foreground">
                    Banka hesaplarınızı ve ödeme yöntemlerinizi yönetin
                  </p>
                </div>
                <Button
                  variant="default"
                  iconName="Plus"
                  iconPosition="left"
                  onClick={() => console.log('Yeni ödeme yöntemi ekle')}
                >
                  Yeni Ekle
                </Button>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {paymentMethods?.map((method) => (
                  <PaymentMethodCard
                    key={method?.id}
                    method={method}
                    onEdit={handleEditPaymentMethod}
                    onDelete={handleDeletePaymentMethod}
                    onSetDefault={handleSetDefaultPaymentMethod}
                  />
                ))}
              </div>

              <div className="bg-card border border-border rounded-lg p-6">
                <h3 className="font-semibold text-foreground mb-4">Otomatik Çekim Ayarları</h3>
                <div className="space-y-4">
                  <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
                    <div>
                      <p className="font-medium text-foreground">Otomatik Para Çekme</p>
                      <p className="text-sm text-muted-foreground">Belirli bir tutara ulaşıldığında otomatik çekim yap</p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input type="checkbox" className="sr-only peer" />
                      <div className="w-11 h-6 bg-muted-foreground/20 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                    </label>
                  </div>
                  <Input
                    type="number"
                    label="Minimum Çekim Tutarı"
                    placeholder="0"
                    description="Bu tutara ulaşıldığında otomatik çekim yapılacak"
                  />
                </div>
              </div>
            </div>
          )}

          {activeTab === 'invoices' && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-xl font-bold text-foreground mb-1">Faturalarınız</h2>
                  <p className="text-sm text-muted-foreground">
                    Tüm faturalarınızı görüntüleyin ve indirin
                  </p>
                </div>
                <Button
                  variant="outline"
                  iconName="Download"
                  iconPosition="left"
                  onClick={() => console.log('Toplu fatura indir')}
                >
                  Toplu İndir
                </Button>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {invoices?.map((invoice) => (
                  <InvoiceCard
                    key={invoice?.id}
                    invoice={invoice}
                    onDownload={handleDownloadInvoice}
                    onView={handleViewInvoice}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </main>
      <MobileNav userRole={userRole} />
      <QuickActions userRole={userRole} />
      {selectedTransaction && (
        <TransactionDetailModal
          transaction={selectedTransaction}
          onClose={() => setSelectedTransaction(null)}
        />
      )}
    </div>
  );
};

export default PaymentCenter;